<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getGoodsReceived"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'goods-received-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-2">Number</div>
        <div class="col-md-2">Date</div>
        <div class="col-md-4">Supplier</div>
        <div class="col-md-2">Order</div>
        <div class="col-md-2 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">

      
        <div class="col-md-2 my-auto">
          <p class="m-0 font-weight-bold">{{ slotProps.item.goods_received_number }}</p>
        </div>

          <div class="col-md-2 my-auto">
          <p class="m-0"> {{
                  moment(new Date(slotProps.item.created_at)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}</p>
        </div>

        <div class="col-md-4 my-auto">
          <p class="m-0" v-if="slotProps.item.supplier">{{ slotProps.item.supplier.name }}</p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0" v-if="slotProps.item.order">{{ slotProps.item.order.order_number }}</p>
        </div>

      


        <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'goods-received-show',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

      

           <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Print"
            @click="vWindow.open(`/pdf/reports/inventory/goods-received/${slotProps.item.id}?cid=${slotProps.item.company_id}`)"
            class="text-secondary table-action-icon"
          >
            <i class="lni lni-printer"></i>
          </span>

         
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'goods-received' })"
      :lazy="true"
    >
      <router-view
        @goodsReceivedCreated="goodsReceivedCreated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import goodsReceivedRepo from "@/api/repos/goodsReceivedRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "id", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "id", label: "Latest", order: "desc" },
        { column: "id", label: "Oldest", order: "asc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getGoodsReceived({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async deleteOrder(id) {
      this.isBusy = true;
      try {
        await goodsReceivedRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the order.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteOrder(id) : false))
        .catch((error) => console.log(error));
    },
    async getGoodsReceived(e) {
      this.isLoad = true;
      try {
        let { data } = await goodsReceivedRepo.goodsReceived(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.goods_received.data;
        this.totalRows = data.goods_received.total;
        this.page = data.goods_received.current_page;
        this.fromRow = data.goods_received.from;
        this.toRow = data.goods_received.to;
        this.lastPage = data.goods_received.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    goodsReceivedCreated() {
      this.$bvToast.toast("Order Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getGoodsReceived({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
